import XMarkIcon from "@/assets/icons/xmark.svg";
import Typography from "@components/Typography";

import styles from "./Error.module.css";

export default function Error(props: { error?: string }) {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.iconContainer}>
          <XMarkIcon width={20} height={20} className={styles.icon} />
        </div>

        <Typography variant="h3" margin="none">
          {L.GENERIC_ERROR}
        </Typography>
      </div>

      <Typography className={styles.lede} margin="none">
        {L.GENERIC_ERROR_LEDE}
      </Typography>

      {props.error && (
        <Typography variant="error" margin="none" className={styles.error}>
          {L.ERROR}: {props.error}
        </Typography>
      )}
    </div>
  );
}
